import { DefinitionList, DefinitionListItem } from "@funcional/react-ui";
import { Grid } from "@material-ui/core";
import { FieldValues, UseFormGetValues, useFormContext } from "react-hook-form";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { IRefundRule } from "@refund/query-fixed-discount-rules/contracts";

const containerSpacing = 3;

export function SummaryForm({
  defaults,
  viewMode,
  editMode,
}: {
  defaults?: IRefundRule,
  viewMode?: boolean,
  editMode?: boolean,
}) {
  const {
    getValues,
  } = useFormContext();

  const summaryData = getSummaryData(getValues, defaults, editMode)
  const formatIntoParagraphs = (array?) => {
    return array.map((item, index) => (
      <p key={index}>{item} %</p>
    ))
  }

  const formatArrayIntoText = (array?): string => {
    if (array?.length > 0 && array.every(elemento => typeof elemento === 'string')) {
      if (array.length === 1) {
        return array[0];
      } else {
        return array.slice(0, -1).join(', ') + ', ' + array.slice(-1);
      }
    }
    return '';
  }
  function formatDate(data: string | Date): string {
    if (data) {
      const dataObjeto = new Date(data);
      const dataFormatada = dataObjeto.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).replace(',', '');

      return dataFormatada;
    }
    return '';
  }

  function formatFormulaAttributes(formulaAttributes) {
    if (formulaAttributes instanceof Array) formulaAttributes = JSON.stringify(formulaAttributes)

    if (formulaAttributes) {
      if (formulaAttributes === '["INDUSTRY_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]') return 'Preço da Indústria (Preço do produto na Indústria x Desconto x Quantidade vendida)';
      if (formulaAttributes === '["UNIT_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]') return 'Preço de Venda (Preço do produto na venda x Desconto x Quantidade vendida)';
    }
    return '';
  }
  return (
    <Grid container spacing={containerSpacing} className="max-w-xl">
      <Grid item xs={12}>
        {(viewMode || editMode) &&
          <DefinitionList className="mb-4">
            <DefinitionListItem label="ID da regra:">
              <span className="font-bold">{summaryData.ruleId}</span>
            </DefinitionListItem>
            <hr />
            <DefinitionListItem label="Criação:">
              <span className="font-bold">
                <IntlDateTime value={summaryData.createdAt} />
              </span>
            </DefinitionListItem>
            <hr />
            <DefinitionListItem label="Última atualização:">
              <span className="font-bold">
                {summaryData.updatedAt !== '-' ?
                  <IntlDateTime value={summaryData.updatedAt} />
                  : <>-</>
                }
              </span>
            </DefinitionListItem>
            <hr />
          </DefinitionList>
        }
        <DefinitionList>
          <DefinitionListItem label="Produto:">
            {summaryData.product}
          </DefinitionListItem>
          <hr />
          <DefinitionListItem label="Fórmula do cálculo de ressarcimento: ">
            {formatFormulaAttributes(summaryData.formulaAttributes)}
          </DefinitionListItem>
          <hr />
          <div className="flex divide-x-2">
            <div className="w-3/6 p-2 bg-gray-50 ">
              <dt className="text-sm font-medium text-center text-gray-500">Efetivo de:</dt>
              <dd className="text-sm font-normal text-center">{formatDate(summaryData.startDate)}</dd>
            </div>
            <div className="w-3/6 p-2 bg-gray-50">
              <dt className="text-sm font-medium text-center text-gray-500">Efetivo até:</dt>
              <dd className="text-sm font-normal text-center">{formatDate(summaryData.endDate)}</dd>
            </div>
          </div>
          <hr />
          <div className="flex divide-x-2">
            <div className="w-3/6 p-2 bg-gray-50 ">
              <dt className="text-sm font-medium text-center text-gray-500">Desconto(s) do Paciente:</dt>
              <dd className="text-sm font-normal text-center">{formatIntoParagraphs(summaryData.ranges.map(ranges => ranges.discount))}</dd>
            </div>
            <div className="w-3/6 p-2 bg-gray-50">
              <dt className="text-sm font-medium text-center text-gray-500">Desconto(s) Fixo:</dt>
              <dd className="text-sm font-normal text-center">{formatIntoParagraphs(summaryData.ranges.map(ranges => ranges.discountRefund))}</dd>
            </div>
          </div>
          <hr />
          <DefinitionListItem label="Rede(s):">
            {formatArrayIntoText(summaryData.headquarters)}
          </DefinitionListItem>
          <hr />
          <DefinitionListItem label="Estado(s):">
            {formatArrayIntoText(summaryData.states)}
          </DefinitionListItem>
        </DefinitionList>
      </Grid>
    </Grid>
  );
}

function getSummaryData(getValues: UseFormGetValues<FieldValues>, defaults?: IRefundRule, editMode?: boolean | undefined) {
  return {
    ruleId: defaults?.rulesId ? defaults.rulesId : "",
    createdAt: defaults?.createdAt ? defaults.createdAt : "",
    updatedAt: defaults?.updatedAt ? defaults.updatedAt !== defaults?.createdAt ? defaults.updatedAt : "-" : "",
    product: defaults?.product && !editMode ? `${defaults.product.name} (${defaults.product.description})` : getValues("product"),
    startDate: defaults?.startDate && !editMode ? defaults.startDate : getValues("startDate"),
    endDate: defaults?.endDate && !editMode ? defaults.endDate : getValues("endDate"),
    ranges: defaults?.ranges && !editMode ? defaults.ranges : getValues("ranges"),
    headquarters: defaults?.configuration?.headquarters && !editMode ? defaults?.configuration?.headquarters.map(h => h.name) : getValues("headquarters"),
    states: defaults?.configuration?.states && !editMode ? defaults?.configuration?.states.map(h => h.name) : getValues("states"),
    formulaAttributes: defaults?.formulaAttributes && !editMode ? JSON.stringify(defaults.formulaAttributes) : getValues("formulaAttributes"),
  }
}
